import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Text } from 'foundations-components/components/Text';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
export const FreePopupFormDeprecation = () => /*#__PURE__*/_jsx(Alert, {
  titleText: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "popupFormsBanner.deprecationNotice.free.title_jsx",
    elements: {
      FormattedDateTime
    },
    options: {
      date: {
        value: '2025-06-04',
        format: 'LL'
      }
    }
  }),
  type: "warning",
  children: /*#__PURE__*/_jsx(Text, {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "popupFormsBanner.deprecationNotice.free.description_jsx",
      options: {
        date: {
          value: '2025-06-04',
          format: 'LL'
        }
      },
      elements: {
        FormattedDateTime
      }
    })
  })
});